<template>
    <v-container>
        <v-row class="about" v-if="ll">
            <v-col>
                <div class="bg-form"></div>
                <div class="pad-20">
                    <h2 class="text-center text-h3 py-3 text-color-white" data-vl="10285">{{ll.i10285}}</h2>
                    <div class="b-icons center">
                        <a :href="ll.i10289" target="_blank"><img class="b-icon" src="/img/facebook.svg" /></a>
                        <!--<a :href="ll.i10290" target="_blank"><img class="b-icon" src="/img/Instagram.svg" /></a>-->
                    </div>
                    <p class="text-justify  mt-20" data-vl="10286" v-html="ll.i10286"></p>
                    <p class="font-weight-black text-h6 mt-20" data-vl="10287">
                        {{ll.i10287}}
                        <span class="ml-20 font-weight-black text-h5" data-vl="10288">{{ll.i10288}}</span>
                    </p>
                    <div class="mt-40 center">
                        <router-link :to="'/start'">
                            <v-btn class="btn-order"
                                   size="x-large"
                                   color="primary"
                            >{{ll.i10258}}</v-btn>
                        </router-link>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "AboutPage",
        computed:{
            ll(){
                return this.$root.ll;
            }
        },
    }
</script>
<style>
    .v-application a{
        text-decoration: none;
    }
</style>
<style scoped>
    .b-icons{
        margin-top: 20px;
    }
    .b-icon{
        width: 48px;
        height: 48px;
        display: inline-block;
        margin: 0 25px 0 0;
    }
    .b-icon:hover{
        opacity: 0.6;
    }
.about{
    width: 96%;
    max-width: 730px;
    margin: 40px auto;
    padding: 20px;
    color: #fff;
    text-shadow: #393f74 1px 0 10px;
    background-color: rgba(10, 5, 100, 0.8);
    border-radius: 10px;
}
.bg-form{

}
    .bg-form{
        width: 100%;
        max-width: inherit;
        overflow: hidden;
        height: 477px;
        z-index: 0;
        opacity: 0.3;
        position: relative;
        display: block;
        content: '';
        background-image: url(http://dev.batumis.com/img/delivery.a24cd977.png);
        background-position: center;
        background-repeat: no-repeat;
        padding: 45px;
        margin-bottom: -477px;
    }
    .pad-20{
        padding: 0 20px;
        position: relative;
        z-index: 1;
    }
@media(min-width: 800px){
    .about{
        padding: 44px;
    }
}

    .mt-20{
        margin-top: 20px;
    }
.mt-40{
    margin-top: 40px;
}
    .ml-20{
        margin-left: 20px;
    }
    .center{
        text-align: center;
    }
</style>